<template>
  <div class="flow-panel">
    <!-- Head -->
    <div class="flow-head">
      <div class="sh-row">
        <button
          v-if="viewMode === 'flow' && flowStep > 1 && flowStep < flowCount"
          class="head-back-btn"
          @click="$emit('prev-step')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </button>
        <h2>{{ flowTitle }}</h2>
        <button
          class="close-x"
          @click="$emit('close-sheet')"
        >
          ×
        </button>
      </div>
      <div
        v-if="viewMode === 'flow' && flowStep < flowCount"
        class="step-track"
      >
        <span
          v-for="i in flowCount"
          :key="i"
          :class="['step-dot', { done: i < flowStep, current: i === flowStep }]"
        />
      </div>
    </div>
    <!-- ── LIVE SESSION DETAIL ── -->
    <div
      v-if="viewMode === 'live-detail'"
      class="sheet-body"
    >
      <selected-live-session
        :item="selectedBooking"
        @click="$emit('finish-and-close')"
      />
    </div>
    <div
      v-else-if="viewMode === 'walk-in-customer'"
      class="sheet-body"
    >
      <walk-in-customer
        :item="selectedBooking"
        @close="$emit('finish-and-close')"
      />
    </div>
    <!-- ── SESSION RECEIPT (History) ── -->
    <div
      v-else-if="viewMode === 'summary'"
      class="sheet-body"
    >
      <selected-history
        type="content"
        :item="selectedBooking"
      />
    </div>
    <template v-else>
      <!-- Body (scrollable) -->
      <div class="flow-body">
        <!-- Step 1 — Find Booking -->
        <div
          v-if="viewMode === 'flow' && flowStep === 1"
          class="sheet-body"
        >
          <div class="step-title">
            Step 1 of {{ flowCount }}
          </div>
          <div class="step-h">
            Enter Booking ID
          </div>
          <div class="search-field">
            <label>Booking ID (customer reads it out)</label>
            <input
              v-model="searchId"
              type="text"
              placeholder="BK-2026-....."
              inputmode="text"
              @keyup="searchReg = null"
            >
          </div>
          <div class="or-divider">
            OR
          </div>
          <div
            class="search-field"
            :class="searchError && 'search-error'"
          >
            <label>Vehicle Registration Number</label>
            <input
              v-model="searchReg"
              type="text"
              pattern="^[A-Za-z]{1,4}-\d{3,4}$"
              placeholder="KGH-67788"
              @keyup="searchId = null"
            >
          </div>
        </div>

        <!-- Step 2 — Verify Customer -->
        <div
          v-else-if="viewMode === 'flow' && flowStep === 2"
          class="sheet-body"
        >
          <div class="step-title">
            Step 2 of 5
          </div>
          <!-- <div class="step-h">
            Is this the right person?
          </div> -->
          <div class="verify-card">
            <div class="vc-head justify-space-between">
              <div class="d-flex gap-1">
                <div class="vc-avatar">
                  {{ selectedBooking.customer_name[0] }}
                </div>
                <div>
                  <div class="vc-name">
                    {{ selectedBooking.customer_name }}
                  </div>
                  <div class="vc-id bk-id-badge">
                    Booking No: {{ selectedBooking.booking_id }}
                  </div>
                </div>
              </div>
              <div class="vc-item full">
                <div class="k">
                  Registration Number
                </div>
                <div class="v">
                  <span class="big-reg">{{
                    selectedBooking.vehicle_reg_no
                  }}</span>
                </div>
              </div>
            </div>
            <div class="vc-grid">
              <div class="vc-item">
                <div class="k">
                  Vehicle
                </div>
                <div class="v">
                  {{ selectedBooking.vehicle_make_name }}-
                  {{ selectedBooking.vehicle_model_name }}
                </div>
              </div>
              <div class="vc-item">
                <div class="k">
                  Phone
                </div>
                <div class="v">
                  {{ selectedBooking.customer_phone_number }}
                </div>
              </div>
            </div>
          </div>
          <div class="match-q">
            Verify the vehicle registration number.
          </div>
          <!--  its shows according to grace period -->
          <div
            v-if="!is_within_grace_time"
            class="warn-banner"
          >
            <v-icon color="orange">
              mdi-alert
            </v-icon>
            <div>
              <div class="t">
                Charging session can only start
                {{ selectedBooking?.booking_match_grace_before_minutes }} mins
                before the Booked slot.
              </div>
              <!-- <div class="d">
                
              </div> -->
            </div>
          </div>
        </div>

        <!-- Step 3 — Safety Check -->
        <div
          v-else-if="viewMode === 'flow' && flowStep === 3"
          class="sheet-body"
        >
          <div class="step-title">
            Step 3 of 5
          </div>
          <div class="step-h">
            Before you start the charger
          </div>
          <div
            :class="['check-item', { checked: checks.booking_id_verified }]"
            @click="checks.booking_id_verified = !checks.booking_id_verified"
          >
            <div class="check-box">
              <v-icon>mdi-check</v-icon>
            </div>
            <div class="check-text">
              Booking ID confirmed<span
                class="sub"
              >{{ selectedBooking.booking_id }} ·
                {{ selectedBooking.vehicle_reg_no }}</span>
            </div>
          </div>
          <div
            :class="['check-item', { checked: checks.connector_verified }]"
            @click="checks.connector_verified = !checks.connector_verified"
          >
            <div class="check-box">
              <v-icon>mdi-check</v-icon>
            </div>
            <div class="check-text">
              Correct port<span
                class="sub"
              >Port-{{ selectedBooking.connector_no }} ·
                {{ selectedBooking.connector_type }} ·
                {{ selectedBooking.connector_power }}kW
              </span>
            </div>
          </div>
          <div
            :class="['check-item', { checked: checks.cable_connected }]"
            @click="checks.cable_connected = !checks.cable_connected"
          >
            <div class="check-box">
              <v-icon>mdi-check</v-icon>
            </div>
            <div class="check-text">
              Cable connected<span
                class="sub"
              >Plugged firmly into the car</span>
            </div>
          </div>
        </div>

        <!-- Step 4 — Charging Started -->
        <div
          v-else-if="viewMode === 'flow' && flowStep === 4"
          class="sheet-body"
        >
          <div class="success-wrap">
            <div class="success-ring success-ring--green">
              <v-icon x-large>
                mdi-lightning-bolt
              </v-icon>
            </div>
            <h2>Booking Verified</h2>
            <!-- <p>Now press the green button on the charger to begin charging</p> -->
            <div class="warn-banner">
              <v-icon color="orange">
                mdi-alert
              </v-icon>
              <div>
                <div class="t">
                  Please start charging through the charger
                </div>
                <div class="d">
                  Charging only starts when you press the physical button on
                  Port-{{ selectedBooking.connector_no }}
                </div>
              </div>
            </div>
            <div class="slot-timer">
              <div class="slot-timer__label">
                Slot ends in
              </div>
              <div class="slot-timer__clock">
                {{ countdownDisplay }}
              </div>
              <div class="slot-timer__until">
                Booked until {{ selectedBooking.end_time_format }}
              </div>
            </div>
            <div class="success-detail">
              <div class="sd-row">
                <span class="k">Customer</span><span class="v">{{ selectedBooking.customer_name }}</span>
              </div>
              <div class="sd-row">
                <span class="k">Port</span><span class="v">Port-{{ selectedBooking.connector_no }}</span>
              </div>
              <div class="sd-row">
                <span class="k">Booked until</span><span class="v">{{ selectedBooking.end_time_format }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 5 — Take Payment -->
        <div
          v-else-if="viewMode === 'flow' && flowStep === 5"
          class="sheet-body"
        >
          <div class="step-title">
            Step 5 of 5
          </div>
          <div class="step-h">
            Collect payment
          </div>
          <div class="pay-summary">
            <div class="lbl">
              Amount to collect
            </div>
            <div class="amt">
              Rs {{ selectedBooking.amount || 0 }}
            </div>
            <div class="kwh">
              {{ selectedBooking.kwh || 0 }} kWh used ·
              {{ selectedBooking.minutes || 0 }}
              min
            </div>
          </div>
          <div class="pay-methods">
            <div
              :class="['pay-opt', { sel: payMethod === 'cash' }]"
              @click="$emit('update:payMethod', 'cash')"
            >
              <v-icon large>
                mdi-cash
              </v-icon>
              <div class="nm">
                Cash
              </div>
            </div>
            <div
              :class="['pay-opt', { sel: payMethod === 'card' }]"
              @click="$emit('update:payMethod', 'card')"
            >
              <v-icon large>
                mdi-credit-card
              </v-icon>

              <div class="nm">
                Card / POS
              </div>
            </div>
            <div
              :class="['pay-opt', { sel: payMethod === 'app' }]"
              @click="$emit('update:payMethod', 'app')"
            >
              <v-icon large>
                mdi-cellphone-text
              </v-icon>
              <div class="nm">
                Pay In App
              </div>
            </div>
          </div>
        </div>

        <!-- Step 6 — Done -->
        <div
          v-else-if="viewMode === 'flow' && flowStep === 6"
          class="sheet-body"
        >
          <div class="success-wrap">
            <div class="success-ring success-ring--green">
              <v-icon>mdi-lightning-bolt</v-icon>
            </div>
            <h2>All Done</h2>
            <p>Session complete and paid</p>
            <div class="success-detail">
              <div class="sd-row">
                <span class="k">Customer</span><span class="v">{{ selectedBooking.customer_name }}</span>
              </div>
              <div class="sd-row">
                <span class="k">Energy</span><span class="v">{{ selectedBooking.kwh || 0 }} kWh</span>
              </div>
              <div class="sd-row">
                <span class="k">Paid</span><span
                  class="v"
                >Rs {{ selectedBooking.amount || 0 }} ·
                  {{
                    payMethod === "cash"
                      ? "Cash"
                      : payMethod === "app"
                        ? "Pay In App"
                        : "Card"
                  }}</span>
              </div>
              <div class="sd-row">
                <span class="k">Receipt</span><span class="v receipt-sent">Sent to customer ✓</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /flow-body -->

      <!-- Footer -->
      <div class="sheet-foot">
        <!-- <template v-if="viewMode === 'live-detail'">
          <selected-live-session type="button" />
        </template> -->
        <!-- <template v-if="viewMode === 'summary'">
          <selected-history
            type="download"
            :item="selectedBooking"
          />
        </template> -->
        <template v-if="flowStep === 1">
          <button
            class="big-btn btn-primary"
            :disabled="!searchId && !searchReg"
            @click="onSearch"
          >
            Search
            <v-icon color="white">
              mdi-arrow-right
            </v-icon>
          </button>
          <div class="helper-text">
            Ask the customer for either one
          </div>
        </template>
        <template v-else-if="flowStep === 2">
          <button
            class="big-btn btn-primary"
            :disabled="!selectedBooking?.is_within_grace_time"
            @click="$emit('go-step', 3)"
          >
            Yes, this is correct
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              width="24"
              height="24"
            >
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
          <div
            class="secondary-link"
            @click="$emit('close-sheet')"
          >
            No — this is not them
          </div>
        </template>
        <template v-else-if="flowStep === 3">
          <v-btn
            color="primary"
            class="big-btn btn-primary"
            height="4.5rem"
            :loading="loading"
            :disabled="!allChecked"
            @click="onStepThree"
          >
            Confirm &amp; Allow Start
          </v-btn>
          <div class="helper-text">
            {{
              allChecked
                ? "All checks done — you can start"
                : "Tick all 3 before starting"
            }}
          </div>
        </template>
        <template v-else-if="flowStep === 4">
          <!-- <button
            class="big-btn btn-primary"
            @click="$emit('go-step', 5)"
          >
            Charging done — Take payment
            <v-icon color="white"> mdi-arrow-right </v-icon>
          </button>
          <div class="helper-text">Come back here when the session ends</div> -->
        </template>
        <template v-else-if="flowStep === 5">
          <!-- <button
            class="big-btn btn-primary"
            :disabled="!payMethod"
            @click="$emit('confirm-payment')"
          >
            Confirm Payment Received
          </button>
          <div class="helper-text">Pick how the customer paid</div> -->
        </template>
        <template v-else-if="viewMode === 'flow' && flowStep === 6">
          <button
            class="big-btn btn-primary"
            @click="$emit('finish-and-close')"
          >
            Back to Bookings
          </button>
        </template>
      </div>
      <!-- Footer -->
    </template>
  </div>
</template>

<script>
export default {
  name: "DetailPanel",
  components: {
    selectedLiveSession: () => import("../sections/SelectedLiveSession.vue"),
    selectedHistory: () => import("../sections/SelectedHistory.vue"),
    WalkInCustomer: () => import("../sections/WalkInCustomer.vue"),
  },
  props: {
    selectedBooking: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: String,
      required: true,
    },
    flowStep: {
      type: Number,
      required: true,
    },
    flowTitle: {
      type: String,
      default: "",
    },
    flowCount: {
      type: Number,
      default: 3,
      required: true,
    },
    checks: {
      type: Object,
      required: true,
    },
    payMethod: {
      type: String,
      default: null,
    },
    allChecked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      // for Step 1
      searchId: null,
      searchReg: null,
      searchError: null,
      //
      // for Step 4
      countdownSec: 0,
      countdownTimer: null,
    };
  },
  computed: {
    countdownDisplay() {
      const totalSeconds = this.countdownSec;

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(seconds).padStart(2, "0")}`;
    },
  },
  watch: {
    selectedBooking() {
      if (this.flowStep == 4) {
        this.startCountdown();
      }
    },
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  mounted() {
    if (this.flowStep == 4) {
      this.startCountdown();
    } else {
      this.stopCountdown();
    }
  },
  methods: {
    // For Step 1
    onSearch() {
      this.searchError = null;
      const params = {
        id: this.searchId || null,
        reg: this.searchReg || null,
      };
      const regx = /^[A-Za-z]{1,4}-\d{3,4}$/; // for Search Reg No
      if (this.searchReg && !regx.test(this.searchReg)) {
        this.searchError = "searchReg";
        this.$store.dispatch(
          "alerts/error",
          "Vehicle regisrtation number is not valid"
        );
        return;
      }
      this.$emit("onSearch", params);
    },
    // For Step 3
    onStepThree() {
      this.loading = true;
      const params = {
        ...this.checks,
        booking_id: this.selectedBooking.booking_id,
      };
      this.$store
        .dispatch("bookingOperator/verifyBooking", params)
        .then(() => {
          this.startCountdown();
          this.$emit("go-step", 4);
        })
        .finally(() => (this.loading = false));
    },

    // For Step 4
    startCountdown() {
      this.stopCountdown();

      if (!this.selectedBooking) return;

      const { booking_date, end_time } = this.selectedBooking;

      // Current Date & Time
      const now = new Date();

      // Booking Date + End Time
      // Example:
      // booking_date = "2026-07-13"
      // end_time = "01:00:00"
      const target = new Date(`${booking_date}T${end_time}`);

      // Remaining seconds
      const diffInSeconds = Math.floor(
        (target.getTime() - now.getTime()) / 1000
      );

      // Booking already expired
      if (diffInSeconds <= 0) {
        this.countdownSec = 0;
        return;
      }

      this.countdownSec = diffInSeconds;

      this.countdownTimer = setInterval(() => {
        if (this.countdownSec > 0) {
          this.countdownSec--;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
  },
};
</script>
